/**
 * @desc 保存
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.StartPortRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/startPort/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
